import api from "api";

const PATH = "/Categoria";
const qs = require("qs");

const SAVE_CATEGORIA = async (categoria) => {
  try {
    if (categoria.categoriaId === 0) {
      const { data } = await api.post(`${PATH}/add`, categoria);
      return data;
    } else {
      const { data } = await api.post(`${PATH}/update`, categoria);
      return data;
    }
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

const GET_LIST_CATEGORIA_FILTRO = async (filtros) => {
  try {
    const { data } = await api.get(`${PATH}/get-list-paged`, {
      params: filtros,
      paramsSerializer: (params) => {
        return qs.stringify(params);
      },
    });
    return data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

const GET_LIST_CATEGORIA_TIPO = async () => {
  try {
    const { data } = await api.get(`${PATH}/get-list-tipo`);
    return data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};
const GET_LIST_CATEGORIA_TIPO_FILTRO = async () => {
  try {
    const { data } = await api.get(`${PATH}/get-list-tipo-filtro`);
    return data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

const GET_CATEGORIAS_POR_TIPO = async (id) => {
  try {
    const { data } = await api.get(`${PATH}/get-categorias-por-tipo`, {
      params: { id },
    });
    return data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};
const GET_CATEGORIAS_LIST = async () => {
  try {
    const { data } = await api.get(`${PATH}/get-list`);
    return data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

const GET_CATEGORIAS_SUPERIORES_POR_TIPO = async (id) => {
  try {
    const { data } = await api.get(
      `${PATH}/get-categorias-superiores-por-tipo`,
      {
        params: { id },
      }
    );
    return data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

const GET_CATEGORIA_ID = async (id) => {
  try {
    const { data } = await api.get(`${PATH}/get/${id}`);
    return data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

const DELETE_CATEGORIA = async (id) => {
  try {
    const { data } = await api.post(`${PATH}/remove/${id}`);
    return data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

const GET_CATEGORIA_ARVORE = async () => {
  try {
    const { data } = await api.get(`${PATH}/get-arvore`);
    return data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

const GET_CATEGORIA_ARVORE_JSON = async () => {
  try {
    const { data } = await api.get(`${PATH}/get-arvore-json`);
    return data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

export {
  DELETE_CATEGORIA,
  GET_LIST_CATEGORIA_FILTRO,
  GET_CATEGORIA_ARVORE,
  GET_CATEGORIA_ARVORE_JSON,
  GET_CATEGORIA_ID,
  GET_LIST_CATEGORIA_TIPO,
  GET_LIST_CATEGORIA_TIPO_FILTRO,
  GET_CATEGORIAS_POR_TIPO,
  GET_CATEGORIAS_SUPERIORES_POR_TIPO,
  SAVE_CATEGORIA,
  GET_CATEGORIAS_LIST,
};
